import * as crm from '../../constants/crm'
import __ from 'lodash'

export default (state = {}, action) => {
    switch (action.type) {
        case crm.CRM_ADD_NEW_LEAD_REQUEST:
            return { ...state, newLeadSave: false, newLeadError: false }
        case crm.CRM_ADD_NEW_LEAD_SUCCESS:
            return { ...state, newLeadSave: true, newLeadError: false }
        case crm.CRM_ADD_NEW_LEAD_ERROR:
            return { ...state, newLeadSave: false, newLeadError: true }
        case crm.CRM_FETCH_LEADS:
            return { ...state, ...action.payload }
        case crm.CRM_FETCH_LEAD:
            let _updatedAction, _statusChangeModalShow, _actions = __.map(action.payload.lead.actions, act => {
                if (act.dzialanie === 'Zmiana statusu') {
                    _updatedAction = act
                    _statusChangeModalShow = true
                }
                return act
            })
            return {
                ...state, lead: {
                    ...state.lead,
                    ...action.payload.lead,
                    actions: [..._actions],
                    updatedAction: _updatedAction,
                    statusChangeModalShow: _statusChangeModalShow
                }
            }
        case crm.CRM_CHANGE_LEAD_ACTION_NAME:
            let updatedAction, statusChangeModalShow
            const actions = state.lead.actions.map(act => {
                if (act.id === action.payload.action_id) {
                    if (action.payload.action_name === 'Zmiana statusu') {
                        statusChangeModalShow = true
                        updatedAction = act
                    } else {
                        act.dzialanie_nowe = action.payload.action_name
                    }
                }
                return act
            })
            return { ...state, lead: { ...state.lead, actions: actions, updatedAction, statusChangeModalShow, statusToChange: null }, }
        case crm.CRM_LEAD_ACTION_STATUS_CHANGE_MODAL_CLOSE:
            return { ...state, lead: { ...state.lead, statusChangeModalShow: false, updatedAction: null } }
        case crm.CRM_LEAD_ACTION_STATUS_CHANGE:
            return { ...state, lead: { ...state.lead, statusToChange: action.payload } }
        case crm.CRM_FETCH_POWIATY:
            return { ...state, powiaty: action.payload }
        case crm.CRM_FETCH_OPERATORS:
            return { ...state, operatorzyFiltered: [], operatorzy: action.payload.users || [] }
        case crm.CRM_POWIAT_CHANGE:
            const operatorzyFiltered = __.filter(state.operatorzy, operator => operator.login_punktu_handlowego === action.payload.value.login)
            return { ...state, lead: { ...state.lead }, operatorzyFiltered }
        case crm.CRM_ADD_NEW_LEAD_ALERT_SHOWN:
            return { ...state, newLeadSave: false }
        case crm.CRM_SET_ZRODLA_KONTAKTU_OPTIONS:
            return { ...state, zrodlaKontaktuOptions: action.payload }
        case crm.CRM_LEAD_EDIT_RESET_PREFETCH:
            return { ...state, lead: undefined, powiaty: undefined, operatorzy: undefined, leadEditPrefetched: false }
        case crm.CRM_LEAD_EDIT_CHECK_PREFETCH:
            console.log(state)
            if (state.lead && state.powiaty && state.operatorzy) {
                let powiatyOptions = __.map(state.powiaty, val => ({
                    label: `${val.powiat}, woj. ${val.wojewodztwo} (${val.login})`,
                    value: val
                }))

                let _powiatyOptions = __.map(state.powiaty, val => ({
                    label: `${val.powiat}, woj. ${val.wojewodztwo}`,
                    value: val
                }))

                const _powiat = _powiatyOptions.find(pow => pow.value.id === state.lead.powiat_id)

                const powiat = powiatyOptions.find(pow => pow.value.login === state.lead.login_obsluga)

                const operatorzyFiltered = __.filter(state.operatorzy, operator => operator.login_punktu_handlowego === state.lead.login_obsluga)

                let operatorzyOptions = __.map(operatorzyFiltered, val => ({
                    label: `${val.imie} ${val.nazwisko} - ${val.login_punktu_handlowego} / ${val.login_operatora}`,
                    value: val
                }))
                let kto_obsluguje = operatorzyOptions.filter(operator => operator.value.login_operatora === state.lead.login_operatora_obsluga)[0]
                let zrodlo_kontaktu = { value: state.lead.zrodlo_kontaktu, label: state.lead.zrodlo_kontaktu }
                return { ...state, lead: { ...state.lead, _powiat, powiat, kto_obsluguje, zrodlo_kontaktu }, operatorzyFiltered, leadEditPrefetched: true }
            }
            return state
        case crm.CRM_TYPY_IMPORTOW_SUCCESS:
            return {
                ...state, importFromFile: {
                    ...state.importFromFile,
                    typyImportow: action.payload,
                    selectedImport: action.payload[0]
                }
            }
        case crm.CRM_SELECT_IMPORT:
            let selectedImport = state.importFromFile.typyImportow.filter(el => el.id === action.payload)[0]
            return { ...state, importFromFile: { ...state.importFromFile, selectedImport } }
        case crm.CRM_IMPORT_FILE_SUCCESS:
            return { ...state, importFromFile: { ...state.importFromFile, result: action.payload } }
        case crm.CRM_CONTACT_LIST_FILTER_CHANGE:
            return { ...state, contactListConf: { ...state.contactListConf, filtered: action.payload } }
        case crm.CRM_CONTACT_LIST_SORT_CHANGE:
            return { ...state, contactListConf: { ...state.contactListConf, sorted: action.payload } }
        case crm.CRM_CONTACT_LIST_RESIZE_CHANGE:
            return { ...state, contactListConf: { ...state.contactListConf, resized: action.payload } }
        case crm.CRM_CONTACT_LIST_CONFIG_UPDATE:
            return { ...state, contactListConf: action.payload }
        default:
            return state;
    }
}